import { v4 as uuidv4 } from 'uuid'

import { Blot, QuillStatic } from '../../types'

import { PAUSE_BLOT_NAME, PAUSE_CLASS_NAME, PAUSE_TAG_NAME } from './constants'
import { PauseValueForGet, PauseValueForSet } from './types'

const QUILL_STORE: {
  Quill?: QuillStatic
} = {}

export const registerPauseBlot = (Quill: QuillStatic) => {
  QUILL_STORE.Quill = Quill

  const Embed = Quill.import('blots/embed')

  class Pause extends Embed {
    static blotName = PAUSE_BLOT_NAME

    static tagName = PAUSE_TAG_NAME

    // static className = PAUSE_CLASS_NAME

    static create(value: PauseValueForSet) {
      const node: HTMLElement = super.create()

      if (!value) {
        return undefined
      }

      const { duration } = value

      const childEl = document.createElement('div')

      /**
       * 아이디의 사용처는 UI 기능 상에서 선택된 엘리멘트를 찾는데에만 사용됨\
       * 영구적으로 저장될 필요가 없고\
       * 다른 엘리멘트와 중복되지 않고\
       * 매번 새로운 아이디가 할당되어도 문제 없음
       */
      childEl.id = uuidv4()
      childEl.className = 'partialOpacity pauseButton'
      childEl.dataset.wordtype = 'pause'
      childEl.innerText = duration.toString()

      node.appendChild(childEl)

      /**
       * blot 바로 뒤에 커서가 붙어있을 때, 한글을 입력하면 자모가 분리되는 현상 해결
       */
      node.setAttribute('contenteditable', 'false')

      return node
    }

    static value(domNode: HTMLElement): PauseValueForGet {
      /**
       * 기존에 저장된 데이터와의 호환성을 위해서 엘리멘트를 찾는 과정이 조금 난해하게 되어 있음
       */
      let el: HTMLElement | null = domNode

      const isRootElement = !!domNode.dataset.wordtype

      if (!isRootElement) {
        el = domNode.querySelector(`.${PAUSE_CLASS_NAME}`)
      }

      if (!el) {
        // throw new Error('Invalid pause node')
        return {
          id: uuidv4(),
          duration: 0,
        }
      }

      const id = el.id
      const duration = parseFloat(el.innerText)

      return {
        id,
        duration,
      }
    }
  }

  Quill.register(Pause, true)

  return Pause
}

export const findClosestPauseEl = (el: HTMLElement) => {
  /**
   * 기존에 저장된 데이터와의 호환성을 위헤서 엘리멘트를 찾는 과정이 조금 난해하게 되어 있음
   */
  return el.closest<HTMLElement>(`${PAUSE_TAG_NAME}:has(.${PAUSE_CLASS_NAME})`)
}

export const findPauseBlot = (
  el: HTMLElement,
):
  | Blot<typeof PAUSE_BLOT_NAME, PauseValueForGet, PauseValueForSet>
  | undefined => {
  const Quill = QUILL_STORE.Quill

  if (!Quill) {
    return
  }

  const closestEl = findClosestPauseEl(el)

  if (!closestEl) {
    return
  }

  return Quill.find(closestEl)
}

export const findPauseBlotById = (id?: string) => {
  if (!id) {
    return
  }

  const el = document.getElementById(id)

  if (!el) {
    return
  }

  return findPauseBlot(el)
}
